import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import RouteChangeHandler from "./RouteChangeHandler";
import SysAdmin from "./SysAdmin";
import Links from "./Links";
import ProtectedRoute from "./utils/ProtectedRoute";
import Sidebar from "./Matrix/components/Sidebar";
import OverviewPage from "./Matrix/pages/OverviewPage";
import LogFeedPage from "./Matrix/pages/LogFeedPage";
import ErrorsPage from "./Matrix/pages/ErrorsPage";
import ActionQueuePage from "./Matrix/pages/ActionQueuePage";
import InsightsPage from "./Matrix/pages/InsightsPage";
import TrendsPage from "./Matrix/pages/TrendsPage";
import VMOverviewPage from "./Matrix/pages/VMOverviewPage";
import VMContainersPage from "./Matrix/pages/VMContainersPage";
import VMLogsPage from "./Matrix/pages/VMLogsPage";

// ./Common/
import Calender from "./Common/Calender";
import clsGrid from "./Common/clsGrid";
import CustomAlert from "./Common/CustomAlert";
import CustomConfirmation from "./Common/CustomConfirmation";

import EL_Calender from "./Common/EL_Calender";
import EL_CollectFlashScore from "./Common/EL_CollectFlashScore";
import EL_ContactUs from "./Common/EL_ContactUs";
import EL_Error from "./Common/EL_Error";
import EL_GetURLContent from "./Common/EL_GetURLContent";
import EL_HTMLEditor from "./Common/EL_HTMLEditor";
import EL_MyPassword from "./Common/EL_MyPassword";
import EL_SelectPeriod from "./Common/EL_SelectPeriod";
import EL_SessionExpiredNew from "./Common/EL_SessionExpiredNew";
import EL_UnauthorisedUsage from "./Common/EL_UnauthorisedUsage";

import HTMLEditor from "./Common/HTMLEditor";
import Loading from "./Common/Loading";
import QnLoading from "./Common/QnLoading";
import SelectPeriod from "./Common/SelectPeriod";
import SendEmail from "./Common/SendEmail";
import SessionExpiredNew from "./Common/SessionExpiredNew";
import Timeout from "./Common/Timeout";


// KineticEducation
import MD_FreeAssessment from "./KineticEducation/Flexischools/MD_FreeAssessment";

// ./DEALER/
import EL_AddEditFamilyUser from "./DEALER/EL_AddEditFamilyUser";
import EL_ApproveDeliveryDockets from "./DEALER/EL_ApproveDeliveryDockets";
import EL_Dealer_UsageAnalysis from "./DEALER/EL_Dealer_UsageAnalysis";
import EL_DealerAdmin from "./DEALER/EL_DealerAdmin";
import EL_DealerAdminMaster from "./DEALER/EL_DealerAdminMaster";
import EL_DealerRegisterFamily_India from "./DEALER/EL_DealerRegisterFamily_India";
import EL_DealerRegisterFamily from "./DEALER/EL_DealerRegisterFamily";
import EL_EditFamilyProfile from "./DEALER/EL_EditFamilyProfile";
import EL_ListFamilies from "./DEALER/EL_ListFamilies";
import EL_ListFamilyUsers from "./DEALER/EL_ListFamilyUsers";
import EL_RegisterDistributors from "./DEALER/EL_RegisterDistributors";


// ./LessonBrowser/
import LessonBrowser from "./LessonBrowser/LessonBrowser";
import LessonViewer from "./LessonBrowser/LessonViewer";
import QuestionViewer from "./LessonBrowser/QuestionViewer";
import SearchQnTypes from "./LessonBrowser/SearchQnTypes";
import Tutorial_PrincipleContents from "./LessonBrowser/Tutorial_PrincipleContents";
import StudentQuestionViewer from "./LessonBrowser/StudentQuestionViewer";

// ./LOGIN/
import EL_Login from "./LOGIN/EL_Login";
import EL_LoginALL from "./LOGIN/EL_LoginALL";
import EL_ManageFamilyUsers from "./LOGIN/EL_ManageFamilyUsers";
import EL_ReportsOption from "./LOGIN/EL_ReportsOption";
import ForgotPassword from "./LOGIN/ForgotPassword";

// ./MathsDoctor/
// ./MathsDoctor/Reports/
import NavigationReport from "./MathsDoctor/Reports/NavigationReport";
import PDFReport from "./MathsDoctor/Reports/PDFReport";
import StillReport from "./MathsDoctor/Reports/StillReport";
import MovingReport from "./MathsDoctor/Reports/MovingReport";

// ./MD_Reports/
import End_of_WeekReport from "./MD_Reports/End_of_WeekReport";
import GenerateBrickWallAndknowledgeGapReport from "./MD_Reports/GenerateBrickWallAndknowledgeGapReport";
import MD_NavReport from "./MD_Reports/MD_NavReport";
import MD_WeeklyPerformanceReport from "./MD_Reports/MD_WeeklyPerformanceReport";
import WLP_Report from "./MD_Reports/WLP_Report";
import MD_MarketingReport from "./MD_Reports/MD_MarketingReport";
import MD_EReport_PDF from "./MD_Reports/MD_EReport_PDF";
import MD_WPReport_PDF from "./MD_Reports/MD_WPReport_PDF";

// ./SALES/
import EL_ActivateProduct from "./SALES/EL_ActivateProduct";
import EL_ListOfInstallations from "./SALES/EL_ListOfInstallations";
import EL_PreAudit from "./SALES/EL_PreAudit";
import EL_SalesMasterPage from "./SALES/EL_SalesMasterPage";
// import EL_SelectProducts from "./SALES/EL_SelectProducts";
import EL_SelectSuburb from "./SALES/EL_SelectSuburb";
import EL_SendActivationEmailToFamily from "./SALES/EL_SendActivationEmailToFamily";



// ./SALES/Dockets/
import EL_DeliveryDocketDetails from "./SALES/Dockets/EL_DeliveryDocketDetails";
import EL_DeliveryDockets from "./SALES/Dockets/EL_DeliveryDockets";
import EL_Print_DeliveryDocketDetails from "./SALES/Dockets/EL_Print_DeliveryDocketDetails";

// ./SALES/NewSales/
import EL_AddDates from "./SALES/NewSales/EL_AddDates";
import EL_BalancePaymentOption from "./SALES/NewSales/EL_BalancePaymentOption";
import EL_CheckCMS from "./SALES/NewSales/EL_CheckCMS";
import EL_CheckLoginID from "./SALES/NewSales/EL_CheckLoginID";
import EL_GetCustomAmtDateMode from "./SALES/NewSales/EL_GetCustomAmtDateMode";
import EL_NewSale_Installments from "./SALES/NewSales/EL_NewSale_Installments";
import EL_NewSale from "./SALES/NewSales/EL_NewSale";
import EL_Print_DeliveryDockets from "./SALES/NewSales/EL_Print_DeliveryDockets";
import EL_Sales_AddPackage from "./SALES/NewSales/EL_Sales_AddPackage";
import EL_SelectPackages from "./SALES/NewSales/EL_SelectPackages";
import EL_ValidateFromDB from "./SALES/NewSales/EL_ValidateFromDB";
import KM_Sales_DeliveryDockets from "./SALES/NewSales/KM_Sales_DeliveryDockets";

// ./SALES/SalesModify/
import EL_SalesModify from "./SALES/SalesModify/EL_SalesModify";

// ./SCHOOL/
import EL_PromoteSchoolStudentsToNextYear from "./SCHOOL/EL_PromoteSchoolStudentsToNextYear";
// ./SCHOOL/Teacher/
// import Dashboard from "./SCHOOL/Teacher/Dashboard";
import EL_ActiveSessionReport from "./SCHOOL/Teacher/EL_ActiveSessionReport";
import EL_AssignMD from "./SCHOOL/Teacher/EL_AssignMD";
import EL_SetMinutes from "./SCHOOL/Teacher/EL_SetMinutes";
import EL_SetWork from "./SCHOOL/Teacher/EL_SetWork";
import EL_SetWorkPhase2 from "./SCHOOL/Teacher/EL_SetWorkPhase2";
import EL_SetWorkPhase3 from "./SCHOOL/Teacher/EL_SetWorkPhase3";
import EL_TeacherMenu from "./SCHOOL/Teacher/EL_TeacherMenu";
import EL_ViewWork from "./SCHOOL/Teacher/EL_ViewWork";


// ./STUDENT/
// ./STUDENT/Reports/
import EL_Certificate from './STUDENT/Reports/EL_Certificate';
import EL_PTReport from './STUDENT/Reports/EL_PTReport';
import EL_Result from './STUDENT/Reports/EL_Result';
import EL_Scores from './STUDENT/Reports/EL_Scores';
import EL_UserDiary from './STUDENT/Reports/EL_UserDiary'
// import EL_PTReport from "./STUDENT/Reports/EL_PTReport";
// import EL_Result from "./STUDENT/Reports/EL_Result";
// import EL_Scores from "./STUDENT/Reports/EL_Scores";
// import EL_UserDiary from "./STUDENT/Reports/EL_UserDiary";

// ./SUPPORT/
import AdditionalStudentsInfo from "./SUPPORT/AdditionalStudentsInfo";
import AssignMD from "./SUPPORT/AssignMD";
import AssignEC from "./SUPPORT/AssignEC";
import DealerDashboard from "./SUPPORT/SupportDashboard";
import EL_AddDNCNumbers_New from "./SUPPORT/EL_AddDNCNumbers_New";
import EL_AddDNCNumbers from "./SUPPORT/EL_AddDNCNumbers";
import EL_AddEditTask from "./SUPPORT/EL_AddEditTask";
import EL_AddPoints from "./SUPPORT/EL_AddPoints";
import EL_AttachFile from "./SUPPORT/EL_AttachFile";
import EL_AttachFileSupport from "./SUPPORT/EL_AttachFileSupport";
import EL_CourtesyCallList from "./SUPPORT/EL_CourtesyCallList";
import EL_CreateDefaultLessonPlan from "./SUPPORT/EL_CreateDefaultLessonPlan";
import EL_CustomerSupportEntryDetails from "./SUPPORT/EL_CustomerSupportEntryDetails";
import EL_FlagedAlertList from "./SUPPORT/EL_FlagedAlertList";
import EL_HTML5SettingforTUT from "./SUPPORT/EL_HTML5SettingforTUT";
import EL_Lessonperformance from "./SUPPORT/EL_Lessonperformance";
import EL_ListOfTasks from "./SUPPORT/EL_ListOfTasks";
import EL_ListofUsersMDNotCompleted from "./SUPPORT/EL_ListofUsersMDNotCompleted";
import EL_ListWLPsRunningout from "./SUPPORT/EL_ListWLPsRunningout";
import EL_MailsSent from "./SUPPORT/EL_MailsSent";
import EL_MDStatus from "./SUPPORT/EL_MDStatus";
import EL_Promote_Family_Student_Grade from "./SUPPORT/EL_Promote_Family_Student_Grade";
import EL_QuestionInsights from "./SUPPORT/EL_QuestionInsights";
import EL_Questionperformance from "./SUPPORT/EL_Questionperformance";
import EL_RemoveLessonsFromWLP from "./SUPPORT/EL_RemoveLessonsFromWLP";
import EL_SearchEngine from "./SUPPORT/EL_SearchEngine";
import EL_SearchEngineDetails from "./SUPPORT/EL_SearchEngineDetails";
import EL_SelectLearningDifficulty from "./SUPPORT/EL_SelectLearningDifficulty";
import EL_ShowCurrentActivities from "./SUPPORT/EL_ShowCurrentActivities";
import EL_ShowStudentLP from "./SUPPORT/EL_ShowStudentLP";
import EL_StudentStudyHistory from "./SUPPORT/EL_StudentStudyHistory";
import EL_StudentPerformanceReport from "./SUPPORT/EL_StudentPerformanceReport";
import EL_Support from "./SUPPORT/EL_Support";
import EL_Testperformance from "./SUPPORT/EL_Testperformance";
import EL_TestSummary from "./SUPPORT/EL_TestSummary";
import EL_ViewLesson from "./SUPPORT/EL_ViewLesson";
import EL_ViewLessonPlan from "./SUPPORT/EL_ViewLessonPlan";
import EL_ViewPoints from "./SUPPORT/EL_ViewPoints";
import SupportLoggedOut from "./SUPPORT/SupportLoggedOut";
import SupportLogin from "./SUPPORT/SupportLogin";
import EL_MDOverallAnalysis from "./SUPPORT/EL_MDOverallAnalysis";

// ./SYSADMIN
import SysAdminLogin from "./SYSADMIN/SysAdminLogin"
import RegisterDistributor from "./DEALER/EL_RegisterDistributors"
import ExpirydateModifiedlog from "./SYSADMIN/ExpirydateModifiedlog";
import Dashboard from "./SYSADMIN/Dashboard";
import EditLogin from "./SYSADMIN/EditLogin";
// ./SYSADMIN/Admin/
import AddNewSchoolCode from "./SYSADMIN/Admin/AddNewSchoolCode";
import ListSchools from "./SYSADMIN/Admin/ListSchools";
import ManageRoles from "./SYSADMIN/Admin/ManageRoles";
import Promote_Family_Student_Grade from "./SYSADMIN/Admin/Promote_Family_Student_Grade";
import PromoteSchoolStudentsToNextYear from "./SYSADMIN/Admin/PromoteSchoolStudentsToNextYear";
import RegisterDistributors from "./SYSADMIN/Admin/RegisterDistributors";
import SchoolDetails from "./SYSADMIN/Admin/SchoolDetails";
import SchoolIPs from "./SYSADMIN/Admin/SchoolIPs";
import SelectCurriculum from "./SYSADMIN/Admin/SelectCurriculum";
import SelectSuburb from "./SYSADMIN/Admin/SelectSuburb";
import SetLoginRoles from "./SYSADMIN/Admin/SetLoginRoles";

// ./SYSADMIN/Data/
import AddDeleteQn from "./SYSADMIN/Data/AddDeleteQn";
import AvatarARD from "./SYSADMIN/Data/AvatarARD";
import CompARD from "./SYSADMIN/Data/CompARD";
import CompViewEntrants from "./SYSADMIN/Data/CompViewEntrants";
import LessonPlanMessages from "./SYSADMIN/Data/LessonPlanMessages";
import ManageAvatars from "./SYSADMIN/Data/ManageAvatars";
import ManageComps from "./SYSADMIN/Data/ManageComps";
import ManageDIC from "./SYSADMIN/Data/ManageDIC";
import ManageKeyWords from "./SYSADMIN/Data/ManageKeyWords";
import ManagePackages from "./SYSADMIN/Data/ManagePackages";
import ManageProducts from "./SYSADMIN/Data/ManageProducts";
import ManageStates from "./SYSADMIN/Data/ManageStates";
import ManageStores from "./SYSADMIN/Data/ManageStores";
import ManageStoresPurchases from "./SYSADMIN/Data/ManageStoresPurchases";
import ManageTopics from "./SYSADMIN/Data/ManageTopics";
import PackagesARD from "./SYSADMIN/Data/PackagesARD";
import PlayGameNEW from "./SYSADMIN/Data/PlayGameNEW";
import ProductsARD from "./SYSADMIN/Data/ProductsARD";
import SelectAgentCodes from "./SYSADMIN/Data/SelectAgentCodes";
import StoresARD from "./SYSADMIN/Data/StoresARD";
import UploadLesson from "./SYSADMIN/Data/UploadLesson";
import ViewAvatarpurchases from "./SYSADMIN/Data/ViewAvatarpurchases";
import WriteDICToDB from "./SYSADMIN/Data/WriteDICToDB";


// ./SYSADMIN/Games/
import ViewGames from "./SYSADMIN/Games/ViewGames";

// ./SYSADMIN/MathsDoctor/
import CreateMathsDoctorLessonPlan from "./SYSADMIN/MathsDoctor/CreateMathsDoctorLessonPlan";
import CreateEnglishCheckLessonPlan from "./SYSADMIN/EnglishCheck/CreateEnglishCheckLessonPlan";
import LinkMDandMW from "./SYSADMIN/MathsDoctor/LinkMDandMW";
import MathsDoctorQuestions from "./SYSADMIN/MathsDoctor/MathsDoctorQuestions";
import ResetMD from "./SYSADMIN/MathsDoctor/ResetMD";

// ./SYSADMIN/Reports/
import ActiveUsersChart from "./SYSADMIN/Reports/ActiveUsersChart";
import AddTutor from "./SYSADMIN/Reports/AddTutor";
import CallAndSupport from "./SYSADMIN/Reports/CallAndSupport";
import CPCCustomersReport from "./SYSADMIN/Reports/CPCCustomersReport";
import CPCInstallersReport from "./SYSADMIN/Reports/CPCInstallersReport";
import DistributorSalesReport from "./SYSADMIN/Reports/DistributorSalesReport";
import ExtentionStudent from "./SYSADMIN/Reports/ExtentionStudent";
import FamilyUsageAnalysis from "./SYSADMIN/Reports/FamilyUsageAnalysis";
import LoginUsage from "./SYSADMIN/Reports/LoginUsage";
import NoOpenTasks from "./SYSADMIN/Reports/NoOpenTasks";
import SchoolUsage from "./SYSADMIN/Reports/SchoolUsage";
import TutorCenterUsage from "./SYSADMIN/Reports/TutorCenterUsage";
import TutorSupportList from "./SYSADMIN/Reports/TutorSupportList";
import TutorSupportReport from "./SYSADMIN/Reports/TutorSupportReport";
import YLALessonsReport from "./SYSADMIN/Reports/YLALessonsReport";
import ProgressMDReport from "./SYSADMIN/Reports/ProgressMDReport";

// ./SYSADMIN/SuperAdmin/
import AddEditSettings from "./SYSADMIN/SuperAdmin/AddEditSettings";
import SuperAdminEditLogin from "./SYSADMIN/SuperAdmin/EditLogin";
import GeneralARD from "./SYSADMIN/SuperAdmin/GeneralARD";
import ListUsers from "./SYSADMIN/SuperAdmin/ListUsers";
import ManageSettings from "./SYSADMIN/SuperAdmin/ManageSettings";
import ShowErrorDetailsForID from "./SYSADMIN/SuperAdmin/ShowErrorDetailsForID";
import ShowErrorLog from "./SYSADMIN/SuperAdmin/ShowErrorLog";
import SysAdminRoles from "./SYSADMIN/SuperAdmin/SysAdminRoles";


// ./SYSADMIN/Support/
import AddDNC from "./SYSADMIN/Support/AddDNC";
import CustomerSupportEntryDetails from "./SYSADMIN/Support/CustomerSupportEntryDetails";
import FlagedAlertList from "./SYSADMIN/Support/FlagedAlertList";
import MailsSent from "./SYSADMIN/Support/MailsSent";
import UserDiary from "./SYSADMIN/Support/UserDiary";
import ViewLesson from "./SYSADMIN/Support/ViewLesson";
import ViewLessonPlan from "./SYSADMIN/Support/ViewLessonPlan";
import ViewPoints from "./SYSADMIN/Support/ViewPoints";
import WLPModifiedLog from "./SYSADMIN/Support/WLPModifiedLog";



// WEBADMIN
// ./WEBADMIN/ADMIN
import EL_AddEditSettings from "./WEBADMIN/ADMIN/EL_AddEditSettings";
import EL_AddEditStates from "./WEBADMIN/ADMIN/EL_AddEditStates";
import EL_AddEditTimeZones from "./WEBADMIN/ADMIN/EL_AddEditTimeZones";
import EL_AddModifyUpdates from "./WEBADMIN/ADMIN/EL_AddModifyUpdates";
import EL_EditLogin from "./WEBADMIN/ADMIN/EL_EditLogin";
import EL_GeneralARD from "./WEBADMIN/ADMIN/EL_GeneralARD";
import EL_ListUsers from "./WEBADMIN/ADMIN/EL_ListUsers";
import EL_ManageRoles from "./WEBADMIN/ADMIN/EL_ManageRoles";
import EL_ManageSettings from "./WEBADMIN/ADMIN/EL_ManageSettings";
import EL_ManageStates from "./WEBADMIN/ADMIN/EL_ManageStates";
import EL_ManageTimeZones from "./WEBADMIN/ADMIN/EL_ManageTimeZones";
import EL_SetLoginRoles from "./WEBADMIN/ADMIN/EL_SetLoginRoles";
import EL_SetSiteMessage from "./WEBADMIN/ADMIN/EL_SetSiteMessage";
import EL_ShowUpdates from "./WEBADMIN/ADMIN/EL_ShowUpdates";
import EL_SysAdminRoles from "./WEBADMIN/ADMIN/EL_SysAdminRoles";
import EL_ListTAUsers from "./WEBADMIN/ADMIN/EL_ListTAUsers";
import EL_TutorAdminRoles from "./WEBADMIN/ADMIN/EL_TutorAdminRoles"


// ./WEBADMIN/DIC
import EL_CheckData from "./WEBADMIN/DIC/EL_CheckData";
import EL_CheckDIC from "./WEBADMIN/DIC/EL_CheckDIC"
import EL_ManageDIC from "./WEBADMIN/DIC/EL_ManageDIC";
import EL_ManageKeyWords from "./WEBADMIN/DIC/EL_ManageKeyWords";
import EL_WriteDICToDB from "./WEBADMIN/DIC/EL_WriteDICToDB";

// ./WEBADMIN/GAMES
import EL_ManageGames from "./WEBADMIN/GAMES/EL_ManageGames";
import { ShowLessonDetails } from "./WEBADMIN/GAMES/ShowLessonDetails";

// ./WEBADMIN/LESSONPLAN
import EL_AddORModifyTip from "./WEBADMIN/LESSONPLAN/EL_AddORModifyTip";
import EL_LessonPlanMessages from "./WEBADMIN/LESSONPLAN/EL_LessonPlanMessages";
import EL_ManageWeeklyTips from "./WEBADMIN/LESSONPLAN/EL_ManageWeeklyTips";
import EL_WeeklyLessonPlanReshudleJobStatus from "./WEBADMIN/LESSONPLAN/EL_WeeklyLessonPlanReshudleJobStatus";

//WEBADMIN/LOGIN
import EL_ManageLogin from "./WEBADMIN/LOGIN/EL_ManageLogin";

// ./WEBADMIN/MAILS
import EL_SendMail from "./WEBADMIN/MAILS/EL_SendMail";

// ./WEBADMIN/MATHSDOCTOR
import EL_LinkMDandMW from "./WEBADMIN/MATHSDOCTOR/EL_LinkMDandMW";
import MD_AddDeleteQn from "./WEBADMIN/MATHSDOCTOR/MD_AddDeleteQn";
import MD_ExceptionError from "./WEBADMIN/MATHSDOCTOR/MD_ExceptionError";
import MD_ManageTopics from "./WEBADMIN/MATHSDOCTOR/MD_ManageTopics";
import MD_ManageVoucherCodes from "./WEBADMIN/MATHSDOCTOR/MD_ManageVoucherCodes";
import MD_ValidateQnTypes from "./WEBADMIN/MATHSDOCTOR/MD_ValidateQnTypes";

// ./WEBADMIN/ENGLISHCHECK
import EC_ManageTopics from "./WEBADMIN/ENGLISHCHECK/EC_ManageTopics";
import EL_LinkECandEW from "./WEBADMIN/ENGLISHCHECK/EL_LinkECandEW";
import ResetEC from "./SYSADMIN/EnglishCheck/ResetEC"
import EnglishCheckQuestions from "./SYSADMIN/EnglishCheck/EnglishCheckQuestions"
import EC_AddDeleteQn from "./WEBADMIN/ENGLISHCHECK/EC_AddDeleteQn"
import EC_ValidateQnTypes from "./WEBADMIN/ENGLISHCHECK/EC_ValidateQnTypes";


// ./WEBADMIN/POINTS
import EL_AvatarARD from "./WEBADMIN/POINTS/EL_AvatarARD";
import EL_CompsARD from "./WEBADMIN/POINTS/EL_CompARD";
import EL_CompViewEntrants from "./WEBADMIN/POINTS/EL_CompViewEntrants";
import EL_CompWinnerDetails from "./WEBADMIN/POINTS/EL_CompWinnerDetails";
import EL_ManageAvatars from "./WEBADMIN/POINTS/EL_ManageAvatars";
import EL_ViewFreeAvatarUsage from "./WEBADMIN/POINTS/EL_ViewFreeAvatarUsage";
import EL_ManageComps from "./WEBADMIN/POINTS/EL_ManageComps";
import EL_ManageStores from "./WEBADMIN/POINTS/EL_ManageStores";
import EL_ManageStoresPurchases from "./WEBADMIN/POINTS/EL_ManageStoresPurchases";
import EL_StoresARD from "./WEBADMIN/POINTS/EL_StoresARD";
import EL_ViewAvatarPurchases from "./WEBADMIN/POINTS/EL_ViewAvatarPurchases";
import ImportVouchersPurchased from "./WEBADMIN/POINTS/ImportVouchersPurchased";


// ./WEBADMIN/PRODUCT/
import EL_ManagePackages from "./WEBADMIN/PRODUCT/EL_ManagePackages";
import EL_ManageProducts from "./WEBADMIN/PRODUCT/EL_ManageProducts";
import EL_ManagePromotions from "./WEBADMIN/PRODUCT/EL_ManagePromotions";
import EL_ModifyCreditLimit from "./WEBADMIN/PRODUCT/EL_ModifyCreditLimit";
import EL_PackagesARD from "./WEBADMIN/PRODUCT/EL_PackagesARD";
import EL_ProductsARD from "./WEBADMIN/PRODUCT/EL_ProductsARD";
import EL_SelectAgentCodes from "./WEBADMIN/PRODUCT/EL_SelectAgentCodes";
import EL_SelectProducts from "./WEBADMIN/PRODUCT/EL_SelectProducts";



// ./WEBADMIN/REPORTS/
import EL_ActiveUsersChart from "./WEBADMIN/REPORTS/EL_ActiveUsersChart";
import EL_FamilyRegisteredFromAPP from "./WEBADMIN/REPORTS/EL_FamilyRegisteredFromAPP";
import EL_FamilyUsageAnalysis from "./WEBADMIN/REPORTS/EL_FamilyUsageAnalysis";
import EL_GeneralQuery from "./WEBADMIN/REPORTS/EL_GeneralQuery";
import EL_LoginUsage from "./WEBADMIN/REPORTS/EL_LoginUsage";
import EL_ReschedulingStatus from "./WEBADMIN/REPORTS/EL_ReschedulingStatus";
import EL_SaveQuery from "./WEBADMIN/REPORTS/EL_SaveQuery";
import EL_SaveStructuredReport from "./WEBADMIN/REPORTS/EL_SaveStructuredReport";
import EL_SchoolUsage from "./WEBADMIN/REPORTS/EL_SchoolUsage";
import EL_ShowCurrentLogins from "./WEBADMIN/REPORTS/EL_ShowCurrentLogins";
import EL_ShowErrorDetailsForID from "./WEBADMIN/REPORTS/EL_ShowErrorDetailsForID";
import EL_ShowErrorLog from "./WEBADMIN/REPORTS/EL_ShowErrorLog";
import EL_StudentsWeeklyLessonPlanReport from "./WEBADMIN/REPORTS/EL_StudentsWeeklyLessonPlanReport";
import EL_TutorCenterUsage from "./WEBADMIN/REPORTS/EL_TutorCenterUsage";
import EL_UserCountGraph from "./WEBADMIN/REPORTS/EL_UserCountGraph";
import EL_ViewFile from "./WEBADMIN/REPORTS/EL_ViewFile";
import EL_ViewWeeklyGuestUsage from "./WEBADMIN/REPORTS/EL_ViewWeeklyGuestUsage";
import KMDistributorSalesReport from "./WEBADMIN/REPORTS/KMDistributorSalesReport";


// ./WEBADMIN/SCHOOLS/
import EL_AddNewSchoolCode from "./WEBADMIN/SCHOOLS/EL_AddNewSchoolCode";
import EL_ListSchools from "./WEBADMIN/SCHOOLS/EL_ListSchools";
import EL_SchoolDetails from "./WEBADMIN/SCHOOLS/EL_SchoolDetails";
import EL_SchoolIPs from "./WEBADMIN/SCHOOLS/EL_SchoolIPs";
import EL_SelectCurriculum from "./WEBADMIN/SCHOOLS/EL_SelectCurriculum";
import MD_ViewQuestion from "./MD_Reports/MD_ViewQuestion";
import MD_ViewQuestionAnswer from "./MD_Reports/MD_ViewQuestionAnswer";
import SupportDashboard from "./SUPPORT/SupportDashboard";
import EC_NavReport from "./EC_Reports/EC_NavReport";

import EC_ViewQuestion from "./EC_Reports/EC_ViewQuestion";
import EC_ViewQuestionAnswer from "./EC_Reports/EC_ViewQuestionAnswer";
import EPDFReport from "./EnglishCheck/Reports/EPDFReport";
import EStillReport from "./EnglishCheck/Reports/EStillReport";


import Writing_Feedback from "./SUPPORT/Writing_Feedback";
import EL_MDAnalysisreport from "./SUPPORT/EL_MDAnalysisreport";
import SysAdminOtp from "./SYSADMIN/SysAdminOtp";





// import EL_AddEditStates from "./WEBADMIN/ADMIN/EL_AddEditStates";



const App: React.FC = () => {
  const [theme, setTheme] = useState<"dark" | "light">(() => {
    const saved = localStorage.getItem("app-theme") as "dark" | "light" | null;
    if (saved) return saved;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      document.body.style.height = `${window.innerHeight - 40}px`;
      document.body.style.width = `${window.innerWidth}px`;
      const mobile = window.innerWidth <= 900;
      setIsMobile(mobile);
      if (mobile) setSidebarOpen(false);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("app-theme", theme);
    document.body.className = theme === "light" ? "light" : "";
  }, [theme]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isMobile && sidebarOpen) setSidebarOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isMobile, sidebarOpen]);

  useEffect(() => {
    document.body.style.overflow = isMobile && sidebarOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isMobile, sidebarOpen]);

  return (
    <Router>
      {/* <RouteChangeHandler /> */}
      <Routes>
        <Route path="/" element={<SysAdminLogin />} />
        <Route path="/SysAdmin/OTP" element={<SysAdminOtp />} />

        <Route path="/LOGIN/ForgotPassword" element={<ForgotPassword />} />

        <Route path="/Links" element={<Links />} />
        <Route path="/Matrix/*" element={
          <div className="matrix-shell" style={{ display: "flex", height: "100vh", background: "var(--bg)", color: "var(--text)", fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif", overflow: "hidden" }}>
            <Sidebar
              open={sidebarOpen}
              isMobile={isMobile}
              theme={theme}
              onLinkClick={() => { if (isMobile) setSidebarOpen(false); }}
              onThemeToggle={() => setTheme(t => t === "dark" ? "light" : "dark")}
              onClose={() => setSidebarOpen(false)}
            />
            <main className="matrix-shell__main" style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0, height: "100%", overflow: "hidden" }}>
              {(!sidebarOpen || isMobile) && (
                <button
                  onClick={() => setSidebarOpen(p => !p)}
                  aria-label="Toggle sidebar"
                  style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 36, height: 36, borderRadius: 8, border: "1px solid var(--border)", background: "var(--surface-soft)", color: "var(--text)", cursor: "pointer", fontSize: 17, margin: 16 }}
                >
                  ☰
                </button>
              )}
              <div className="matrix-shell__content" style={{ flex: 1, overflow: "auto", padding: isMobile ? 16 : 24 }}>
                <Routes>
                  <Route path="/" element={<OverviewPage />} />
                  <Route path="/logs" element={<LogFeedPage />} />
                  <Route path="/errors" element={<ErrorsPage />} />
                  <Route path="/actions" element={<ActionQueuePage />} />
                  <Route path="/insights" element={<InsightsPage />} />
                  <Route path="/trends" element={<TrendsPage />} />
                  <Route path="/vm-overview" element={<VMOverviewPage />} />
                  <Route path="/vm-containers" element={<VMContainersPage />} />
                  <Route path="/vm-logs" element={<VMLogsPage />} />
                </Routes>
              </div>
            </main>
          </div>
        } />

        <Route element={<ProtectedRoute />}>
        //DEALER
          <Route path="/DEALER/EL_ListFamilies" element={<EL_ListFamilies />} />
          <Route path="/DEALER/EL_ListFamilyUsers" element={<EL_ListFamilyUsers />} />
          <Route path="/DEALER/EL_EditFamilyProfile" element={<EL_EditFamilyProfile />} />
          <Route path="/DEALER/EL_AddEditFamilyUser" element={<EL_AddEditFamilyUser />} />
          <Route path="/DEALER/EL_ApproveDeliveryDockets" element={<EL_ApproveDeliveryDockets />} />
          <Route path="/DEALER/EL_DealerRegisterFamily" element={<EL_DealerRegisterFamily />} />
          <Route path="/DEALER/EL_Dealer_UsageAnalysis" element={<EL_Dealer_UsageAnalysis />} />
          <Route path="/DEALER/EL_DealerAdmin" element={<EL_DealerAdmin />} />
          <Route path="/SUPPORT/EL_MDOverallAnalysis" element={<EL_MDOverallAnalysis />} />
          <Route path="/SUPPORT/EL_MDAnalysisreport" element={<EL_MDAnalysisreport />} />

      //KineticEducation
          <Route path="/KineticEducation/Flexischools/MD_FreeAssessment" element={<MD_FreeAssessment />} />
          <Route path="/SUPPORT/Writing_Feedback" element={<Writing_Feedback />} />

//COMMON
          <Route path="/Common/SendEmail" element={<SendEmail />} />

          {/* SYSADMIN */}

          <Route path="/SysAdmin" element={<SysAdmin />} />
          <Route path="/SYSADMIN/Dashboard" element={<Dashboard />} />
          <Route path="/SYSADMIN/UserDiary" element={<UserDiary />} />
          <Route path="/SYSADMIN/EditLogin" element={<EditLogin />} />
          <Route path="/SYSADMIN/ExpirydateModifiedlog" element={<ExpirydateModifiedlog />} />


        //LOGIN
          <Route path="/LOGIN/EL_ManageFamilyUsers" element={<EL_ManageFamilyUsers />} />


          // Admin
          <Route path="/SYSADMIN/Admin/ListSchools" element={<ListSchools />} />

          // Reports
          <Route path="/SYSADMIN/Reports/TutorSupportReport" element={<TutorSupportReport />} />
          <Route path="/SYSADMIN/Reports/YLALessonsReport" element={<YLALessonsReport />} />
          <Route path="/SYSADMIN/Reports/ProgressMDReport" element={<ProgressMDReport />} />
          <Route path="/SYSADMIN/Reports/TutorSupportList" element={<TutorSupportList />} />
          <Route path="/SYSADMIN/Reports/CallAndSupport" element={<CallAndSupport />} />
          <Route path="/SYSADMIN/Reports/CPCInstallersReport" element={<CPCInstallersReport />} />
          <Route path="/SYSADMIN/Reports/NoOpenTasks" element={<NoOpenTasks />} />
          <Route path="/SYSADMIN/Reports/AddTutor" element={<AddTutor />} />
          <Route path="/SYSADMIN/Reports/ExtensionStudent" element={<ExtentionStudent />} />

          // MathsDoctor
          <Route path="/SYSADMIN/MathsDoctor/CreateMathsDoctorLessonPlan" element={<CreateMathsDoctorLessonPlan />} />
          <Route path="/SYSADMIN/EnglishCheck/CreateEnglishCheckLessonPlan" element={<CreateEnglishCheckLessonPlan />} />
          <Route path="/SYSADMIN/MathsDoctor/ResetMD" element={<ResetMD />} />
          <Route path="/SYSADMIN/MathsDoctor/MathsDoctorQuestions" element={<MathsDoctorQuestions />} />

          // Support
          <Route path="/SYSADMIN/Support/UserDiary" element={<UserDiary />} />
          <Route path="/SUPPORT/EL_ViewLessonPlan" element={<EL_ViewLessonPlan />} />
          <Route path="/SYSADMIN/Support/WLPModifiedLog" element={<WLPModifiedLog />} />
          <Route path="/SYSADMIN/Support/ViewPoints" element={<ViewPoints />} />


          {/* WEBADMIN */}
          // POINTS
          <Route path="/WebAdmin/POINTS/EL_ManageStores" element={<EL_ManageStores />} />
          <Route path="/WebAdmin/POINTS/EL_ManageAvatars" element={<EL_ManageAvatars />} />
          <Route path="/WebAdmin/POINTS/EL_ViewFreeAvatarUsage" element={<EL_ViewFreeAvatarUsage />} />
          <Route path="/WebAdmin/POINTS/EL_ManageComps" element={<EL_ManageComps />} />

          // PRODUCT
          <Route path="/WebAdmin/PRODUCT/EL_ManageProducts" element={<EL_ManageProducts />} />
          <Route path="/WebAdmin/PRODUCT/EL_ManagePackages" element={<EL_ManagePackages />} />
          <Route path="/WebAdmin/PRODUCT/EL_ManagePromotions" element={<EL_ManagePromotions />} />
          <Route path="/WebAdmin/PRODUCT/EL_ModifyCreditLimit" element={<EL_ModifyCreditLimit />} />
          <Route path="/WEBADMIN/PRODUCT/EL_SelectProducts" element={<EL_SelectProducts />} />
          {/* <Route path="/WEBADMIN/PRODUCT/EL_PackagesARD" element={<EL_PackagesARD />} /> */}

          // MATHSDOCTOR
          <Route path="/WebAdmin/MATHSDOCTOR/MD_ManageTopics" element={<MD_ManageTopics />} />
          <Route path="/WebAdmin/MATHSDOCTOR/MD_AddDeleteQn" element={<MD_AddDeleteQn />} />
          <Route path="/WebAdmin/MATHSDOCTOR/MD_ManageVoucherCodes" element={<MD_ManageVoucherCodes />} />
          <Route path="/WebAdmin/MATHSDOCTOR/EL_LinkMDandMW" element={<EL_LinkMDandMW />} />
          <Route path="/WebAdmin/MATHSDOCTOR/MD_ExceptionError" element={<MD_ExceptionError />} />
          <Route path="/WebAdmin/MATHSDOCTOR/MD_ValidateQnTypes" element={<MD_ValidateQnTypes />} />


          //ENGLISHCHECK
          <Route path="/WebAdmin/ENGLISHCHECK/EC_ManageTiopics" element={<EC_ManageTopics />} />
          <Route path="/WebAdmin/ENGLISHCHECK/EL_LinkECandEW" element={<EL_LinkECandEW />} />
          <Route path="/SYSADMIN/EnglishCheck/ResetEC" element={<ResetEC />} />
          <Route path="/WebAdmin/ENGLISHCHECK/EC_AddDeleteQn" element={<EC_AddDeleteQn />} />
          <Route path="/SYSADMIN/EnglishCheck/EnglishCheckQuestions" element={<EnglishCheckQuestions />} />
          <Route path="/WebAdmin/ENGLISHCHECK/EC_ValidateQnTypes" element={<EC_ValidateQnTypes />} />

          // ADMIN
          <Route path="/WEBADMIN/ADMIN/EL_ListUsers" element={<EL_ListUsers />} />
          <Route path="/WEBADMIN/ADMIN/EL_EditLogin" element={<EL_EditLogin />} />
          <Route path="/WEBADMIN/ADMIN/EL_SysAdminRoles" element={<EL_SysAdminRoles />} />
          <Route path="/WEBADMIN/ADMIN/EL_GeneralARD" element={<EL_GeneralARD />} />
          <Route path="/WEBADMIN/ADMIN/EL_SetSiteMessage" element={<EL_SetSiteMessage />} />
          <Route path="/WEBADMIN/ADMIN/EL_ShowUpdates" element={<EL_ShowUpdates />} />
          <Route path="/WEBADMIN/ADMIN/EL_ManageRoles" element={<EL_ManageRoles />} />
          <Route path="/WEBADMIN/ADMIN/EL_ManageSettings" element={<EL_ManageSettings />} />
          <Route path="/WebAdmin/Admin/EL_ManageStates" element={<EL_ManageStates />} />
          <Route path="/WebAdmin/Admin/EL_AddEditStates" element={<EL_AddEditStates />} />
          <Route path="/WEBADMIN/ADMIN/EL_ListTAUsers" element={<EL_ListTAUsers />} />
          <Route path="/WEBADMIN/ADMIN/EL_TutorAdminRoles" element={<EL_TutorAdminRoles />} />

          // REPORTS
          <Route path="/WEBADMIN/REPORTS/EL_GeneralQuery" element={<EL_GeneralQuery />} />
          <Route path="/WEBADMIN/REPORTS/EL_TutorCenterUsage" element={<EL_TutorCenterUsage />} />
          <Route path="/WEBADMIN/REPORTS/EL_SchoolUsage" element={<EL_SchoolUsage />} />
          <Route path="/WEBADMIN/REPORTS/EL_FamilyUsageAnalysis" element={<EL_FamilyUsageAnalysis />} />
          <Route path="/WEBADMIN/REPORTS/EL_LoginUsage" element={<EL_LoginUsage />} />
          <Route path="/WEBADMIN/REPORTS/EL_FamilyRegisteredFromAPP" element={<EL_FamilyRegisteredFromAPP />} />
          <Route path="/WEBADMIN/REPORTS/EL_SaveStructuredReport" element={<EL_SaveStructuredReport />} />
          <Route path="/WEBADMIN/REPORTS/EL_ShowErrorLog" element={<EL_ShowErrorLog />} />
          <Route path="/WEBADMIN/REPORTS/EL_ShowErrorDetailsForID" element={<EL_ShowErrorDetailsForID />} />
          <Route path="/WEBADMIN/PRODUCT/EL_SelectAgentCodes" element={<EL_SelectAgentCodes />} />
          <Route path="/WEBADMIN/REPORTS/EL_ShowCurrentLogins" element={<EL_ShowCurrentLogins />} />
          <Route path="/WEBADMIN/REPORTS/EL_UserCountGraph" element={<EL_UserCountGraph />} />
          <Route path="/WEBADMIN/REPORTS/KMDistributorSalesReport" element={<KMDistributorSalesReport />} />


          // SCHOOLS
          <Route path="/WEBADMIN/SCHOOLS/EL_ListSchools" element={<EL_ListSchools />} />
          <Route path="/WEBADMIN/SCHOOLS/EL_AddNewSchoolCode" element={<EL_AddNewSchoolCode />} />
          <Route path="/WEBADMIN/SCHOOLS/EL_SchoolDetails" element={<EL_SchoolDetails />} />
          <Route path="/WEBADMIN/SCHOOLS/EL_SchoolIPs" element={<EL_SchoolIPs />} />
          <Route path="/WEBADMIN/SCHOOLS/EL_SelectCurriculum" element={<EL_SelectCurriculum />} />

          // DIC
          <Route path="/WEBADMIN/DIC/EL_ManageDIC" element={<EL_ManageDIC />} />
          <Route path="/WEBADMIN/DIC/EL_WriteDICToDB" element={<EL_WriteDICToDB />} />
          <Route path="/WEBADMIN/DIC/EL_ManageKeyWords" element={<EL_ManageKeyWords />} />
          <Route path="/WEBADMIN/DIC/EL_CheckData" element={<EL_CheckData />} />
          <Route path="/WEBADMIN/DIC/EL_CheckDIC" element={<EL_CheckDIC />} />

          // LESSONPLAN
          <Route path="/WEBADMIN/LESSONPLAN/EL_ManageWeeklyTips" element={<EL_ManageWeeklyTips />} />
          <Route path="/WEBADMIN/LESSONPLAN/EL_LessonPlanMessages" element={<EL_LessonPlanMessages />} />

        //LOGIN
          <Route path="/WEBADMIN/LOGIN/EL_ManageLogin" element={<EL_ManageLogin />} />

          // MAILS
          <Route path="/WEBADMIN/MAILS/EL_SendMail" element={<EL_SendMail />} />

          // GAMES
          <Route path="/WEBADMIN/GAMES/EL_ManageGames" element={<EL_ManageGames />} />


        //STUDENT/REPORTS
          <Route path="/STUDENT/Reports/EL_UserDiary" element={<EL_UserDiary />} />
          <Route path="/STUDENT/Reports/EL_PTReport" element={<EL_PTReport />} />

          {/* SUPPORT */}
          <Route path="/SUPPORT/SupportDashboard" element={<SupportDashboard />} />
          <Route path="/SUPPORT/AdditionalStudentsInfo" element={<AdditionalStudentsInfo />} />
          <Route path="/SUPPORT/AssignMD" element={<AssignMD />} />
          <Route path="/SUPPORT/AssignEC" element={<AssignEC />} />
          <Route path="/SUPPORT/EL_ListOfTasks" element={<EL_ListOfTasks />} />
          <Route path="/SUPPORT/EL_AddEditTask" element={<EL_AddEditTask />} />
          <Route path="/SUPPORT/EL_ViewPoints" element={<EL_ViewPoints />} />
          <Route path="/SUPPORT/EL_Promote_Family_Student_Grade" element={<EL_Promote_Family_Student_Grade />} />
          <Route path="/SUPPORT/EL_AttachFileSupport" element={<EL_AttachFileSupport />} />
          <Route path="/SUPPORT/EL_MailsSent" element={<EL_MailsSent />} />
          <Route path="/SUPPORT/EL_ViewLesson" element={<EL_ViewLesson />} />
          <Route path="/SUPPORT/EL_ListWLPsRunningout" element={<EL_ListWLPsRunningout />} />
          <Route path="/SUPPORT/EL_AddPoints" element={<EL_AddPoints />} />
          <Route path="/SUPPORT/EL_CreateDefaultLessonPlan" element={<EL_CreateDefaultLessonPlan />} />
          <Route path="/SUPPORT/EL_MDStatus" element={<EL_MDStatus />} />
          <Route path="/SUPPORT/EL_ShowCurrentActivities" element={<EL_ShowCurrentActivities />} />
          <Route path="/SUPPORT/EL_SelectLearningDifficulty" element={<EL_SelectLearningDifficulty />} />
          <Route path="/SUPPORT/EL_Questionperformance" element={<EL_Questionperformance />} />
          <Route path="/SUPPORT/EL_StudentStudyHistory" element={<EL_StudentStudyHistory />} />
          <Route path="/SUPPORT/EL_StudentPerformanceReport" element={<EL_StudentPerformanceReport />} />

          <Route path="/SUPPORT/EL_QuestionInsights" element={<EL_QuestionInsights />} />
          <Route path="/SUPPORT/EL_Lessonperformance" element={<EL_Lessonperformance />} />
          <Route path="/SUPPORT/EL_Testperformance" element={<EL_Testperformance />} />
          <Route path="/SUPPORT/EL_TestSummary" element={<EL_TestSummary />} />
          <Route path="/SUPPORT/EL_CourtesyCallList" element={<EL_CourtesyCallList />} />
          <Route path="/SUPPORT/EL_CustomerSupportEntryDetails" element={<EL_CustomerSupportEntryDetails />} />
          <Route path="/SUPPORT/EL_FlagedAlertList" element={<EL_FlagedAlertList />} />
          <Route path="/SUPPORT/EL_AddDNCNumbers" element={<EL_AddDNCNumbers />} />
          <Route path="/SUPPORT/EL_AddDNCNumbers_New" element={<EL_AddDNCNumbers />} />
          <Route path="/SUPPORT/EL_RemoveLessonsFromWLP" element={<EL_RemoveLessonsFromWLP />} />
          <Route path="/SUPPORT/EL_ListofUsersMDNotCompleted" element={<EL_ListofUsersMDNotCompleted />} />
          <Route path="/SUPPORT/DealerDashboard" element={<DealerDashboard />} />
          <Route path="/SUPPORT/SupportLogin" element={<SupportLogin />} />
          <Route path="/SUPPORT/EL_SearchEngine" element={<EL_SearchEngine />} />
          <Route path="/SUPPORT/EL_SearchEngineDetails" element={<EL_SearchEngineDetails />} />
          <Route path="/SUPPORT/SupportLoggedOut" element={<SupportLoggedOut />} />
          <Route path="/SUPPORT/EL_AttachFile" element={<EL_AttachFile />} />

          {/* SCHOOL */}
          <Route path="/SCHOOL/EL_PromoteSchoolStudentsToNextYear" element={<EL_PromoteSchoolStudentsToNextYear />} />
          <Route path="/SCHOOL/Teacher/EL_SetWork" element={<EL_SetWork />} />
          <Route path="/SCHOOL/Teacher/EL_SetWorkPhase2" element={<EL_SetWorkPhase2 />} />
          <Route path="/SCHOOL/Teacher/EL_SetWorkPhase3" element={<EL_SetWorkPhase3 />} />
          <Route path="/SCHOOL/Teacher/EL_ViewWork" element={<EL_ViewWork />} />

          {/* DEALER */}

          <Route path="/DEALER/EL_RegisterDistributors" element={<RegisterDistributor />} />

          {/* LessonBrowser */}

          <Route path="/LessonBrowser/LessonViewer" element={<LessonViewer />} />
          <Route path="/LessonBrowser/LessonBrowser" element={<LessonBrowser />} />
          <Route path="/LessonBrowser/QuestionViewer" element={<QuestionViewer />} />
          <Route path="/LessonBrowser/SearchQnTypes" element={<SearchQnTypes />} />
          <Route path="/LessonBrowser/Tutorial_PrincipleContents" element={<Tutorial_PrincipleContents />} />
          <Route path="/LessonBrowser/StudentQuestionViewer" element={<StudentQuestionViewer />} />


          {/* MathsDoctor */}
        //Reports
          <Route path="/MathsDoctor/Reports/StillReport" element={<StillReport />} />
          <Route path="/MathsDoctor/Reports/NavigationReport" element={<NavigationReport />} />
          <Route path="/MathsDoctor/Reports/PDFReport" element={<PDFReport />} />
          <Route path="/EnglishCheck/Reports/EPDFReport" element={<EPDFReport />} />
          <Route path="/EnglishCheck/Reports/EStillReport" element={<EStillReport />} />
          <Route path="/MathsDoctor/Reports/MovingReport" element={<MovingReport />} />

          {/* MD Reports */}
          <Route path="/MD_Reports/MD_WeeklyPerformanceReport" element={<MD_WeeklyPerformanceReport />} />
          <Route path="/MD_Reports/MD_NavReport" element={<MD_NavReport />} />
          <Route path="/MD_Reports/MD_ViewQuestion" element={<MD_ViewQuestion />} />
          <Route path="/MD_Reports/MD_ViewQuestionAnswer" element={<MD_ViewQuestionAnswer />} />
          <Route path="/EC_Reports/EC_ViewQuestion" element={<EC_ViewQuestion />} />
          <Route path="/EC_Reports/EC_ViewQuestionAnswer" element={<EC_ViewQuestionAnswer />} />
          <Route path="/MD_Reports/End_of_WeekReport" element={<End_of_WeekReport />} />
          <Route path="/MD_Reports/GenerateBrickWallAndknowledgeGapReport" element={<GenerateBrickWallAndknowledgeGapReport />} />
          <Route path="/MD_Reports/WLP_Report" element={<WLP_Report />} />
          <Route path="/MD_Reports/MD_MarketingReport" element={<MD_MarketingReport />} />
          <Route path="/MD_Reports/MD_EReport_PDF" element={<MD_EReport_PDF />} />
          <Route path="/MD_Reports/MD_WPReport_PDF" element={<MD_WPReport_PDF />} />

          {/* ENGLISHCHECK */}
          <Route path="/EC_Reports/EC_NavReport" element={<EC_NavReport />} />


        //SALES
          <Route path="/SALES/EL_SelectSuburb" element={<EL_SelectSuburb />} />

      //SALES/DOCKETS
          <Route path="/SALES/Dockets/EL_DeliveryDocketDetails" element={<EL_DeliveryDocketDetails />} />
          <Route path='/SALES/Dockets/EL_DeliveryDockets' element={<EL_DeliveryDockets />} />
          <Route path="/SALES/Dockets/EL_Print_DeliveryDocketDetails" element={<EL_Print_DeliveryDocketDetails />} />

      // .SALES/SalesModify
          <Route path="/SALES/SalesModify/EL_SalesModify" element={<EL_SalesModify />} />


      //SALES/NEWSALES
          <Route path="/SALES/NewSales/EL_AddDates" element={<EL_AddDates />} />
          <Route path="/SALES/NewSales/EL_CheckCMS" element={<EL_CheckCMS />} />
          <Route path="/SALES/NewSales/EL_Sales_AddPackage" element={<EL_Sales_AddPackage />} />
          <Route path="/SALES/NewSales/EL_SelectPackages" element={<EL_SelectPackages />} />
          <Route path="/SALES/NewSales/EL_ValidateFromDB" element={<EL_ValidateFromDB />} />
          <Route path="/SALES/NewSales/KM_Sales_DeliveryDockets" element={<KM_Sales_DeliveryDockets />} />

          {/* <Route path="/" element={<SysAdminLogin />} />
        <Route path="/SysAdmin" element={<SysAdmin />} />
        <Route path="/SysAdmin/Dashboard" element={<Dashboard />} />

        <Route path="/WebAdmin/POINTS/EL_ManageStores" element={<EL_ManageStores />} />
        <Route path="/WebAdmin/POINTS/EL_ManageAvatars" element={<EL_ManageAvatars />} />
        <Route path="/WebAdmin/POINTS/EL_ManageComps" element={<EL_ManageComps />} />
        <Route path="/WebAdmin/MATHSDOCTOR/MD_ManageTopics" element={<MD_ManageTopics />} />
        <Route path="/WebAdmin/MATHSDOCTOR/MD_AddDeleteQn" element={<MD_AddDeleteQn />} />
        <Route path="/WebAdmin/PRODUCT/EL_ManageProducts" element={<EL_ManageProducts />} />
        <Route path="/WebAdmin/MATHSDOCTOR/MD_ManageVoucherCodes" element={<MD_ManageVoucherCodes />} />
        <Route path="/WebAdmin/MATHSDOCTOR/EL_LinkMDandMW" element={<EL_LinkMDandMW />} />
        <Route path="/WebAdmin/PRODUCT/EL_ManagePackages" element={<EL_ManagePackages />} />
        <Route path="/WebAdmin/MATHSDOCTOR/MD_ExceptionError" element={<MD_ExceptionError />} />
        <Route path="/WebAdmin/PRODUCT/EL_ManagePromotions" element={<EL_ManagePromotions />} />
        <Route path="/WebAdmin/SCHOOLS/EL_ListSchools" element={<EL_ListSchools />} />
        <Route path="/WebAdmin/SCHOOLS/EL_AddNewSchoolCode" element={<EL_AddNewSchoolCode />} />
        <Route path="/SCHOOL/EL_PromoteSchoolStudentsToNextYear" element={<EL_PromoteSchoolStudentsToNextYear />} />
        <Route path="/SUPPORT/EL_Promote_Family_Student_Grade" element={<EL_Promote_Family_Student_Grade />} />
        <Route path="/SUPPORT/EL_ListOfTasks" element={<EL_ListOfTasks />} />

        <Route path="/SUPPORT/EL_AddEditTask" element={<EL_AddEditTask />} />
        <Route path="/SUPPORT/AssignMD" element={<AssignMD />} />
        <Route path="/SUPPORT/EL_ViewPoints" element={<EL_ViewPoints />} />
        <Route path="/SUPPORT/EL_AttachFileSupport" element={<EL_AttachFileSupport />} />
        <Route path="/SUPPORT/EL_MailsSent" element={<EL_MailsSent />} />
        <Route path="/SCHOOL/Teacher/EL_SetWork" element={<EL_SetWork />} />
        <Route path="/SCHOOL/Teacher/EL_SetWorkPhase2" element={<EL_SetWorkPhase2 />} />
        <Route path="/DEALER/EL_RegisterDistributors" element={<RegisterDistributor />} />
        <Route path="/WEBADMIN/ADMIN/EL_ListUsers" element={<EL_ListUsers />} />
        <Route path="/WEBADMIN/ADMIN/EL_EditLogin" element={<EL_EditLogin />} />
        <Route path="/WEBADMIN/ADMIN/EL_SysAdminRoles" element={<EL_SysAdminRoles />} />
        <Route path="/WEBADMIN/ADMIN/EL_GeneralARD" element={<EL_GeneralARD />} />
        <Route path="/WEBADMIN/PRODUCT/EL_SelectAgentCodes" element={<EL_SelectAgentCodes />} />
        <Route path="/SCHOOL/Teacher/EL_SetWorkPhase3" element={<EL_SetWorkPhase3 />} />
        <Route path="/WEBADMIN/GAMES/EL_ManageGames" element={<EL_ManageGames />} />
        <Route path="/SUPPORT/EL_ViewLesson" element={<EL_ViewLesson />} />
        <Route path="/SUPPORT/EL_ListWLPsRunningout" element={<EL_ListWLPsRunningout />} />
        <Route path="/Support/EL_StudentStudyHistory" element={<EL_StudentStudyHistory />} />
        <Route path="/SCHOOL/Teacher/EL_ViewWork" element={<EL_ViewWork />} />
        <Route path="/SUPPORT/EL_AddPoints" element={<EL_AddPoints />} />
        <Route path="/SUPPORT/EL_CreateDefaultLessonPlan" element={<EL_CreateDefaultLessonPlan />} />
        <Route path="/SYSADMIN/MathsDoctor/CreateMathsDoctorLessonPlan" element={<CreateMathsDoctorLessonPlan />} />
        <Route path="/Support/EL_MDStatus" element={<EL_MDStatus />} />
        <Route path="/WebAdmin/Reports/EL_LoginUsage" element={<EL_LoginUsage />} />
        <Route path="/Support/EL_SelectLearningDifficulty" element={<EL_SelectLearningDifficulty />} />
        <Route path="/SYSADMIN/Support/ViewLessonPlan" element={<EL_ViewLessonPlan />} />
        <Route path="/LessonBrowser/LessonViewer" element={<LessonViewer />} />
        <Route path="/LessonBrowser/LessonBrowser" element={<LessonBrowser />} />
        <Route path="/LessonBrowser/QuestionViewer" element={<QuestionViewer />} />
        <Route path="/LessonBrowser/SearchQnTypes" element={<SearchQnTypes />} />
        <Route path="/SUPPORT/EL_Questionperformance" element={<EL_Questionperformance />} />
        <Route path="/SUPPORT/EL_QuestionInsights" element={<EL_QuestionInsights />} />
        <Route path="/SUPPORT/EL_Lessonperformance" element={<EL_Lessonperformance />} />
        <Route path="/SUPPORT/EL_Testperformance" element={<EL_Testperformance />} />
        <Route path="/SUPPORT/EL_TestSummary" element={<EL_TestSummary />} />
        <Route path="/SYSADMIN/Support/WLPModifiedLog" element={<WLPModifiedLog />} />
        <Route path="/LessonBrowser/Tutorial_PrincipleContents" element={<Tutorial_PrincipleContents />} />
        <Route path="/SYSADMIN/EditLogin" element={<EditLogin />} />
        <Route path="/SYSADMIN/ExpirydateModifiedlog" element={<ExpirydateModifiedlog />} />
        <Route path="/SYSADMIN/Reports/TutorSupportReport" element={<TutorSupportReport />} />
        <Route path="/SYSADMIN/Reports/TutorSupportList" element={<TutorSupportList />} />
        <Route path="/SYSADMIN/Reports/CallAndSupport" element={<CallAndSupport />} />
        <Route path="/SYSADMIN/Reports/CPCInstallersReport" element={<CPCInstallersReport />} />
        <Route path="/SYSADMIN/Reports/NoOpenTasks" element={<NoOpenTasks />} />
        <Route path="/SYSADMIN/Reports/AddTutor" element={<AddTutor />} />
        <Route path="/SYSADMIN/Reorts/SchoolUsage" element={<SchoolUsage />} />
        <Route path="/SYSADMIN/Admin/ListSchools" element={<ListSchools />} />
        <Route path="/WEBADMIN/REPORTS/EL_GeneralQuery" element={<EL_GeneralQuery />} />
        <Route path="/WEBADMIN/REPORTS/EL_TutorCenterUsage" element={<EL_TutorCenterUsage />} />
        <Route path="/WEBADMIN/REPORTS/EL_SchoolUsage" element={<EL_SchoolUsage />} />
        <Route path="/WEBADMIN/REPORTS/EL_FamilyUsageAnalysis" element={<EL_FamilyUsageAnalysis />} />
        <Route path="/MD_Reports/MD_WeeklyPerformanceReport" element={<MD_WeeklyPerformanceReport />} />
        <Route path="/WEBADMIN/DIC/EL_ManageDIC" element={<EL_ManageDIC />} />
        <Route path="/WEBADMIN/DIC/EL_WriteDICToDB" element={<EL_WriteDICToDB />} />
        <Route path="/WEBADMIN/DIC/EL_ManageKeyWords" element={<EL_ManageKeyWords />} />
        <Route path="/WEBADMIN/LESSONPLAN/EL_ManageWeeklyTips" element={<EL_ManageWeeklyTips />} />
        <Route path="/SYSADMIN/Reports/ExtensionStudent" element={<ExtentionStudent />} />
        <Route path="/WEBADMIN/REPORTS/EL_SchoolUsage" element={<EL_SchoolUsage />} />
        <Route path="/SUPPORT/EL_CourtesyCallList" element={<EL_CourtesyCallList />} />
        <Route path="/SUPPORT/EL_CustomerSupportEntryDetails" element={<EL_CustomerSupportEntryDetails />} />
        <Route path="/SUPPORT/EL_FlagedAlertList" element={<EL_FlagedAlertList />} />
        <Route path="/SUPPORT/EL_AddDNCNumbers" element={<EL_AddDNCNumbers />} />
        <Route path="/SUPPORT/ELListofUsers_MDNotCompleted" element={<EL_ListofUsersMDNotCompleted />} />
        <Route path="/SUPPORT/EL_AddDNCNumbers_New" element={<EL_AddDNCNumbers />} />
        <Route path="/WEBADMIN/ADMIN/EL_SetSiteMessage" element={<EL_SetSiteMessage />} />
        <Route path="/WEBADMIN/ADMIN/EL_ShowUpdates" element={<EL_ShowUpdates />} />
        <Route path="/WEBADMIN/MAILS/EL_SendMail" element={<EL_SendMail />} />
        <Route path="/WEBADMIN/ADMIN/EL_ManageRoles" element={<EL_ManageRoles />} />
        <Route path="/WEBADMIN/LESSONPLAN/EL_LessonPlanMessages" element={<EL_LessonPlanMessages />} />
        <Route path="/WEBADMIN/SCHOOLS/EL_SchoolDetails" element={<EL_SchoolDetails />} />
        <Route path="/WEBADMIN/SCHOOLS/EL_SchoolIPs" element={<EL_SchoolIPs />} />
        <Route path="/WebAdmin/Admin/EL_ManageStates" element={<EL_ManageStates />} />
        <Route path="/WebAdmin/Admin/EL_AddEditStates" element={<EL_AddEditStates />} />
        <Route path="/WEBADMIN/REPORTS/EL_FamilyRegisteredFromAPP" element={<EL_FamilyRegisteredFromAPP />} />
        <Route path="/SYSADMIN/MathsDoctor/ResetMD" element={<ResetMD />} />
        <Route path="/WEBADMIN/ADMIN/EL_ManageSettings" element={<EL_ManageSettings />} />
        <Route path="/SYSADMIN/MathsDoctor/MathsDoctorQuestions" element={< MathsDoctorQuestions />} />
        <Route path="/MathsDoctor/Reports/StillReport" element={<StillReport />} />
        <Route path="/MathsDoctor/Reports/NavigationReport" element={<NavigationReport />} />
        <Route path="/MathsDoctor/Reports/PDFReport" element={<PDFReport />} />
        <Route path="/SUPPORT/EL_RemoveLessonsFromWLP" element={<EL_RemoveLessonsFromWLP />} />
        <Route path="/MD_Reports/MD_NavReport" element={<MD_NavReport />} /> */}
        </Route>
      </Routes>
    </Router>
  );
};

export default App;

//EL_CustomerSupportEntryDetails
